import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  DEMO_LESSON_COURSE,
  DEMO_LESSON_COURSE_ALL,
  DEMO_LESSON_COURSE_CREATE,
  DEMO_LESSON_COURSE_LIST,
  DEMO_LESSON_EVALUATION_ASSIGNED,
  DEMO_LESSON_EVALUATION_CATEGORY,
  DEMO_LESSON_EVALUATION_LIST,
  DEMO_LESSON_EVALUATION_PRINCIPAL,
  DEMO_LESSON_EVALUATION_REPORT,
  DEMO_LESSON_EVALUATION_RESPONSE_ALL,
  DEMO_LESSON_MODULE,
  DEMO_LESSON_MODULE_ALL,
  DEMO_LESSON_MODULE_CREATE,
  DEMO_LESSON_MODULE_LIST,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const demoLessonEvaluationSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const demoLessonEvaluationListSelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_EVALUATION_LIST]
)

export const demoLessonEvaluationCategorySelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_EVALUATION_CATEGORY]
)

export const demoLessonEvaluationPrincipalSelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_EVALUATION_PRINCIPAL]
)

export const demoLessonEvaluationResponseAllSelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_EVALUATION_RESPONSE_ALL]
)

export const demoLessonEvaluationAssignedSelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_EVALUATION_ASSIGNED]
)

export const demoLessonCourseSelector = createSelector(demoLessonEvaluationSelector, data => data[DEMO_LESSON_COURSE])

export const demoLessonCourseAllSelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_COURSE_ALL]
)

export const demoLessonCourseListSelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_COURSE_LIST]
)

export const demoLessonCourseCreateSelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_COURSE_CREATE]
)

export const demoLessonCourseAllOptionsSelector = createSelector(demoLessonCourseAllSelector, courseAll => {
  return {
    loading: courseAll.loading,
    error: courseAll.error,
    options: Array.isArray(courseAll.data)
      ? courseAll.data.map(item => ({ label: item.title || '', value: item.id }))
      : [],
  }
})

export const demoLessonModuleSelector = createSelector(demoLessonEvaluationSelector, data => data[DEMO_LESSON_MODULE])

export const demoLessonModuleAllSelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_MODULE_ALL]
)

export const demoLessonModuleListSelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_MODULE_LIST]
)

export const demoLessonModuleCreateSelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_MODULE_CREATE]
)

export const demoLessonEvaluationReportSelector = createSelector(
  demoLessonEvaluationSelector,
  data => data[DEMO_LESSON_EVALUATION_REPORT]
)
